import { SectionOrFilter } from "../filterTypes"
import { messages } from "./messages"

//Fields that you can search by keyword on the search input.
export const stockDocumentsListFields = [
    "identifier",
    "identifierAnalyzed",
    "identifierNumber",
    "identifierKeyword",
    "contact.name",
    "contact.nameAnalyzed",
    "contact.nameKeyword",
    "contact.organizationNameKeyword",
    "contact.organizationNameAnalyzed",
]

export const stockDocumentsListTotals = [
]

export const getStockDocumentsFilters = (context) => {
    const availableFilters: SectionOrFilter[] =
        [
            {
                section: context.intl?.formatMessage(messages["most_used_filters"]),
            },
            {
                nameId: "statuses",
                label: context.intl?.formatMessage(messages["status"]),
                type: "select",
                filterMatch: "statusObj.id",
                typeOfSelect: "stock-document-status-select",
                placeHolder: context.intl?.formatMessage(messages["status_filter_placeholder"]),
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "isArchived",
                label: context.intl?.formatMessage(messages["is_archived"]),
                filterMatch: "isArchived",
                type: "boolean",
                placeHolder: "Show archived",
                initialValue: "",
                initialSelect: "is",
            },
            {
                nameId: "createdAt",
                label: context.intl?.formatMessage(messages["created_at"]),
                filterMatch: "createdAt",
                type: "date",
                initialValue: { startDate: null, endDate: null },
                initialSelect: "is"
            },
            {
                section: context.intl?.formatMessage(messages["contact_related_filters"]),
            },
            {
                nameId: "contactId",
                label: context.intl?.formatMessage(messages["contact_id"]),
                filterMatch: "contactId",
                type: "select",
                typeOfSelect: "customer-select",
                initialValue: "",
                initialSelect: "isOneOf"
            },
            {
                nameId: "name",
                label: context.intl?.formatMessage(messages["contact_name"]),
                filterMatch: "contact.name",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "firstName",
                label: context.intl?.formatMessage(messages["contact_first_name"]),
                filterMatch: "contact.firstName",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "lastName",
                label: context.intl?.formatMessage(messages["contact_last_name"]),
                filterMatch: "contact.lastName",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "organizationName",
                label: context.intl?.formatMessage(messages["contact_organization_name"]),
                filterMatch: "contact.organizationNameKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "contactType",
                label: context.intl?.formatMessage(messages["contact_type"]),
                filterMatch: "contact.type",
                type: "select",
                typeOfSelect: "contactType-select",
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "phoneNumber",
                label: context.intl?.formatMessage(messages["contact_phonenumber"]),
                filterMatch: "contact.phoneNumberKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "taxNumber",
                label: context.intl?.formatMessage(messages["tax_number"]),
                filterMatch: "contact.taxNumber",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "email",
                label: context.intl?.formatMessage(messages["contact_email"]),
                filterMatch: "contact.emailKeyword",
                type: "text",
                initialValue: "",
                initialSelect: "is"
            },
            {
                section: context.intl?.formatMessage(messages["product_related_filters"]),
            },
            {
                nameId: "productId",
                label: context.intl?.formatMessage(messages["product_id"]),
                filterMatch: "rows.id",
                filterMatchNotOneOf: "rowsObject.id",
                type: "select",
                subtype: "nested",
                typeOfSelect: "product-select",
                initialValue: [],
                initialSelect: "isOneOf"
            },
            {
                nameId: "productTitle",
                label: context.intl?.formatMessage(messages["product_title"]),
                filterMatch: "rows.title",
                filterMatchNot: "rowsObject.title",
                type: "text",
                subtype: "nested",
                initialValue: "",
                initialSelect: "is"
            },
            {
                nameId: "productSku",
                label: context.intl?.formatMessage(messages["product_sku"]),
                filterMatch: "rows.sku",
                filterMatchNot: "rowsObject.sku",
                type: "text",
                subtype: "nested",
                initialValue: "",
                initialSelect: "is"
            },
            {

                nameId: "productLabel",
                label: context.intl?.formatMessage(messages["product_label"]),
                filterMatch: "rows.labelIds",
                filterMatchNotOneOf: "rowsObject.labelIds",
                type: "select",
                subtype: "nested",
                typeOfSelect: "product-label-select",
                initialValue: [],
                initialSelect: "isOneOf"
            },
        ]
    return availableFilters
}


// WEBPACK FOOTER //
// ./src/common/search-filter/search/stockDocumentsFilters/stockDocumentsFilters.ts